import React, {useContext} from "react";
import {Route, Routes, useLocation, useNavigate} from "react-router-dom";
import {AuthContext} from "../../context/AuthContext";

import AdminGTB from "./admin/AdminGTB";
import AdminGTBView from "./admin/AdminGTBView";
import AdminUsers from "./admin/AdminUsers";
import AdminUserShow from "./admin/AdminUserShow";

const AdminIndex = () => {

    const location = useLocation();
    const {currentUser} = useContext(AuthContext);
    const navigate = useNavigate();

    return (
        <div>
            <div className='container p-0'>
                <div className="hero-section">
                    <div className="row mx-auto w-100">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="tag mt-0">Admin</div>
                        </div>
                    </div>
                </div>


                <div className="row">
                    <div className="col-md-3">
                        <div className="card text-bg-dark">
                            <div className="card-header">Menu</div>
                            <ul className="list-group list-group-flush">
                                <a href="#" onClick={()=>navigate('gtb')} className="list-group-item list-group-item-action" aria-current="true">
                                    Guess The Balance
                                </a>
                                <a href="#" onClick={()=>navigate('users')} className="list-group-item list-group-item-action" aria-current="true">
                                    Users
                                </a>
                            </ul>
                        </div>

                    </div>
                    <div className="col-md-9">
                        <Routes location={location}>
                            <Route path="gtb" element={<AdminGTB />} />
                            <Route path="gtb/:id" element={<AdminGTBView />} />
                            <Route path="users" element={<AdminUsers />} />
                            <Route path="users/:id" element={<AdminUserShow />} />
                        </Routes>
                    </div>
                </div>


            </div>

        </div>
    );
}

export default AdminIndex;